import { useMemo } from "react";
import URI from "urijs";
import generateId from "logic/generateId";
import useCreateSearch from "views/hooks/useCreateSearch";
import Routes from "routing/Routes";
import { nonInfoPriorities } from "components/events/Constants";
import View from "views/logic/views/View";
import ViewState from "views/logic/views/ViewState";
import UpdateSearchForWidgets from "views/logic/views/UpdateSearchForWidgets";
import Search from "views/logic/search/Search";
import QueryGenerator from "views/logic/queries/QueryGenerator";
import { createElasticsearchQueryString } from "views/logic/queries/Query";
import { timeRangeToQueryParameter } from "views/logic/TimeRange";
import { serializeTimeRange } from "components/common/EntityFilters/helpers/timeRange";
import AggregationWidget from "views/logic/aggregationbuilder/AggregationWidget";
import AggregationWidgetConfig from "views/logic/aggregationbuilder/AggregationWidgetConfig";
import Series from "views/logic/aggregationbuilder/Series";
import NumberVisualizationConfig from "views/logic/aggregationbuilder/visualizations/NumberVisualizationConfig";
export const DEFAULT_TIME_RANGE_SECONDS = 86400;
export const messagesTodayLink = (timeRange) => new URI(Routes.SEARCH).addQuery({ q: "", ...timeRangeToQueryParameter(timeRange) }).toString();
export const alertsOrEventsLink = (timeRange, alert) => new URI(Routes.ALERTS.LIST).addQuery("page", 1).addQuery("filters", [
  ...nonInfoPriorities.map((priority) => `priority=${priority}`),
  `timestamp=${serializeTimeRange(timeRange)}`,
  `alert=${alert}`
]).toString();
export const numberWidget = ({
  title,
  timeRange,
  queryString = "",
  streams = [],
  link
}) => ({
  title,
  widget: AggregationWidget.builder().id(generateId()).timerange(timeRange).context(link).query(createElasticsearchQueryString(queryString)).streams(streams).config(
    AggregationWidgetConfig.builder().series([Series.forFunction("count()")]).visualization("numeric").visualizationConfig(NumberVisualizationConfig.create(true, "NEUTRAL", "bottom-left")).rollup(false).build()
  ).build()
});
const buildViewState = (entries) => ViewState.create().toBuilder().titles({ widget: Object.fromEntries(entries.map(({ widget, title }) => [widget.id, title])) }).widgets(entries.map(({ widget }) => widget)).widgetPositions(Object.fromEntries(entries.map(({ widget, position }) => [widget.id, position]))).build();
const buildView = (entries, timeRange) => {
  const query = QueryGenerator(void 0, void 0, void 0, timeRange);
  const search = Search.create().toBuilder().queries([query]).build();
  const view = View.create().toBuilder().newId().type(View.Type.Dashboard).state({ [query.id]: buildViewState(entries) }).search(search).build();
  return Promise.resolve(UpdateSearchForWidgets(view));
};
const useWelcomeSearch = (entries, timeRange) => {
  const view = useCreateSearch(
    // `useCreateSearch` creates a new search on the server for every new promise it receives, so the promise
    // must only be recreated when the widgets or the time range actually change.
    useMemo(() => buildView(entries, timeRange), [entries, timeRange])
  );
  return { view, entries };
};
export default useWelcomeSearch;
